import React from 'react';

const Messaging = () => {
  return <div />;
};
export default Messaging;
